import React, { PropsWithChildren } from "react";

interface Props {
  className?: string;
}

const FlexContent: React.FC<PropsWithChildren<Props>> = (
  props,
): React.ReactElement => {
  return (
    <div
      className={`${props.className} flex flex-col justify-between sm:flex-row sm:items-center`}
    >
      {props.children}
    </div>
  );
};

export default FlexContent;
